<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-18 09:26:13
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-09-04 13:59:49
-->
<template>
  <div id="main" :class="['wh100', device, language]">
    <template v-if="device == 'pc'">
      <header :class="['head-page', scroll_type == 'down' ? 'navbar-down' : '']" v-if="$route.meta.showHearder">
        <pc-heard ref="headMenu" :class="[$route.meta.hearderNum ? activeMenuIndex == '/college' ? 'navbar-default navbar-default-active': 'navbar-default' : '']" :default-active="activeMenuIndex" :scroll="scroll" />
      </header>
      <section class="wid100 main-content" id="content" ref="main_content">
        <div
          :native="false"
          :noresize="false"
          class="wh100"
          wrap-class="content-view"
        >
          <transition name="fade" mode="out-in">
            <keep-alive :include="/^keep-alive-/">
              <router-view ref="contentView" v-if="isRouterAlive" :key="key" />
            </keep-alive>
          </transition>
        </div>
      </section>
      <footer v-if="$route.meta.showFooter">
        <pc-footer class="posrel"/>
      </footer>
    </template>
    <template v-if="device == 'm'">
      <header>
        <div :class="['head-page', scroll > 170 ? activeMenuIndex.indexOf('college') != -1 ? 'hearder_college navbar-default' : 'navbar-default':'', scroll > 875 || scroll_type == 'down'?'navbar-up':'navbar-down', $route.meta.hearderNum ? 'navbar-default' : '']">
          <m-heard ref="headMenu" :default-active="activeMenuIndex" :scroll="scroll"/>
        </div>
      </header>
      <section ref="main_content">
        <transition name="fade" mode="out-in">
          <router-view ref="contentView" ></router-view>
        </transition>
      </section>
      <footer>
        <m-footer/>
      </footer>
      <div v-if="scroll >= 500" class="back_top" @click="backTop"><img :src="require('@/assets/images/backtop.png')" alt="" srcset=""></div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { throttle } from '@/utils'
import PcHeard from '@/components/pc/HeadMenu' // 头部
import PcFooter from '@/components/pc/Footer' // 底部
import mHeard from '@/components/m/HeadMenu' // 头部
import mFooter from '@/components/m/Footer' // 底部

const whitelist = ['/privacy_policy', '/use_clause', '/guidance', '/en/guidance']

export default {
  name: 'AppMain',
  provide () { // 提供
    return {
      reload: this.reload
    }
  },
  components: {
    'pc-heard': PcHeard,
    'pc-footer': PcFooter,
    'm-heard': mHeard,
    'm-footer': mFooter
  },
  data () {
    return {
      isRouterAlive: true,
      activeMenuIndex: this.$route.path, // 选中菜单
      scroll: 0,
      scroll_top: 0,
      scroll_type: 'up'
    }
  },
  computed: {
    ...mapGetters(['device', 'language']),
    key () {
      return this.$route.path
    }
  },
  watch: {
    '$route' (newV, oldV) {
      this.activeMenuIndex = newV.path
      this.removeMenuScroll()
      this.setMenuScroll()
    },
    scroll_top (newV, oldV) {
      this.$store.dispatch('app/setScrollTop', newV)
    }
  },
  created () {
    // if (this.device === 'm') {
    //   if ((this.language === 'en' && this.$route.path.indexOf('/cooperate') !== -1) || (this.language !== 'en' && this.$route.path.indexOf('/cooperate/license') !== -1)) {
    //     this.$router.replace('/').catch(() => {})
    //   }
    // }
  },
  mounted () {
    this.setMenuScroll()
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    setMenuScroll () {
      this.menu = throttle(this.menu)
      this.menu()
      if (this.device === 'pc') {
        this.listenerScroll()
      }
      window.addEventListener('scroll', this.menu, true)
    },
    listenerScroll () {
      const pathList = ['/innovative', '/job', '/news', '/college', '/scienceResearch']
      if (pathList.includes(this.activeMenuIndex)) {
        this.$route.meta.hearderNum = 0
      }
    },
    menu (e) {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if (this.device === 'm') {
        if (this.scroll_top < this.scroll) {
          // 下滚
          this.scroll_type = 'down'
        } else {
          // 上滚
          this.scroll_type = 'up'
        }
        if (this.activeMenuIndex.indexOf('/innovative') !== -1) {
          this.$route.meta.hearderNum = this.scroll > 30 ? 1 : 0
        }
      } else {
        const height = document.getElementsByClassName('scrollBox')[0] && document.getElementsByClassName('scrollBox')[0].clientHeight
        if (whitelist.includes(this.activeMenuIndex)) {
          this.$route.meta.hearderNum = 1
        } else {
          if (this.activeMenuIndex === '/college') {
            this.$route.meta.hearderNum = this.scroll > 180 ? 1 : 0
          } else {
            if (this.activeMenuIndex.indexOf('/innovative') !== -1) {
              this.$route.meta.hearderNum = this.scroll > 30 ? 1 : 0
            } else {
              this.$route.meta.hearderNum = this.scroll / (height - 90) > 1 ? 1 : 0
            }
          }
        }
        if (this.scroll_top < this.scroll && this.scroll > 30) {
          // 下滚
          this.scroll_type = 'down'
        } else {
          // 上滚
          this.scroll_type = 'up'
        }
      }
      this.scroll_top = this.scroll
    },
    removeMenuScroll () {
      window.removeEventListener('scroll', this.menu, true)
    },
    // 返回顶部
    backTop () {
      let timer = setInterval(() => {
        this.scroll_top -= 200
        if (this.scroll_top <= 0) {
          window.scrollTo(0, 0)
          clearInterval(timer)
          timer = null
        }
        window.scrollTo(0, this.scroll_top)
      }, 50)
    }
  },
  destroyed () {
    this.removeMenuScroll()
  }
}
</script>
<style lang="less">
#main.pc {
  min-height: 100vh;
  .head-page {
    // height: 82px !important;
    position: fixed;
    width: 100%;
    z-index: 9;
    top: 0;
    // border-bottom:1px solid rgba(255,255,255,0.16);
    -webkit-transition:top .5s;
    -moz-transition: top .5s;
    -ms-transition: top .5s;
    -o-transition: top .5s;
    transition:top .5s;
    &.navbar-down{
      top: -90PX;
    }
  }
  .main-content {
    min-height: 100vh;
  }
  .el-loading-mask {
    height: calc(100vh - 90PX);
  }
}

#main.m {
  .head-page{
    height: 100px !important;
    position: fixed;
    left: 0;
    right: 0;
    top: -1px;
    width: 100%;
    z-index: 9;
    -webkit-transition:top .2s;
    -moz-transition: top .2s;
    -ms-transition: top .2s;
    -o-transition: top .2s;
    transition:top .2s;
    &.navbar-default{
      // border-bottom:1px solid rgba(255,255,255,0.16);
      // -webkit-box-shadow: 0px 5px 5px 0px rgba(100, 100, 100, 0.1);
      // box-shadow: 0px 5px 5px 0px rgba(100, 100, 100, 0.1);
      // background: #ffffff;
      background: #00A0E9;
    }
    &.hearder_college{
      background: #0B337B;
    }
  }
  &.navbar-up{
    top: -90px;
  }
  &.navbar-down{
    top: 0px;
  }
  .back_top{
    width: 100px;
    height: 100px;
    text-align: center;
    position: fixed;
    right: 20px;
    bottom: 80px;
    padding: 20px;
    cursor: pointer;
    z-index: 6;
    img {
      width: 100%;
    }
  }
}
</style>
